// Single committed theme: Purple-forward MorEdge-inspired look. Green stays ONLY as
// the P&L signature color so it "pops" against the purple/violet UI surfaces.
// Old themes deleted per user feedback ("zero purple, wanted more purple/blue/pink vibe").
export const THEMES = {
  "tradegreen-v2": {
    id: "tradegreen-v2",
    name: "TradeGreen Pro",
    tagline: "Violet-first with a green P&L accent.",
    fonts: {
      heading: "'Geist', 'Inter', system-ui, sans-serif",
      body: "'Geist', 'Inter', system-ui, sans-serif",
      mono: "'Geist Mono', 'JetBrains Mono', ui-monospace, monospace",
    },
    colors: {
      background: "#08080A",
      surface: "rgba(20, 20, 28, 0.6)",
      surface2: "rgba(30, 30, 42, 0.85)",
      border: "rgba(255, 255, 255, 0.07)",
      textPrimary: "#FAFAFA",
      textSecondary: "rgba(250, 250, 250, 0.72)",
      textMuted: "rgba(250, 250, 250, 0.42)",
      // GREEN — punchy money-green. Only used for positive P&L, gains, and wins.
      // Not on buttons or UI chrome. #3EE07C = a vibrant, slightly-mint money-green
      // that pops on dark surfaces without feeling neon.
      greenHero: "#3EE07C",
      greenSoft: "rgba(62, 224, 124, 0.14)",
      greenGlow: "0 4px 20px rgba(62, 224, 124, 0.30)",
      // LOSS — negative P&L
      lossHero: "#F43F5E",
      // ACCENT — PRIMARY UI COLOR — violet — used on buttons, active states, chips, tabs
      accent: "#A855F7",
      accentSoft: "rgba(168, 85, 247, 0.15)",
      accentGlow: "0 8px 32px rgba(168, 85, 247, 0.35)",
      // Purple gradient for hero cards
      accentGradient: "linear-gradient(135deg, #A855F7 0%, #6366F1 50%, #8B5CF6 100%)",
    },
    radius: "14px",
    panel: {
      className: "bg-[var(--surface)] border border-[var(--border)] rounded-2xl backdrop-blur-sm",
      shadow: "0 4px 24px -12px rgba(0, 0, 0, 0.5)",
    },
    wordmark: { style: "modern-clean", displayName: "TradeGreen" },
    charts: { grid: "rgba(255, 255, 255, 0.06)", line: "#3EE07C", area: "url(#tg-clean-area)", axis: "rgba(250, 250, 250, 0.4)" },
  },
};

// Alias the old keys so any stale localStorage falls back cleanly to the new theme
// without erroring out.
THEMES["neon-command"] = THEMES["tradegreen-v2"];
THEMES["swiss-terminal"] = THEMES["tradegreen-v2"];
THEMES["executive-suite"] = THEMES["tradegreen-v2"];
THEMES["tactile-matte"] = THEMES["tradegreen-v2"];

export const DEFAULT_THEME_ID = "tradegreen-v2";
export const THEME_STORAGE_KEY = "tg_theme_v2";  // new key so old lime-cached state is bypassed

export const themeList = () => [THEMES["tradegreen-v2"]];
